import { render, staticRenderFns } from "./archivos-LDP-anios.vue?vue&type=template&id=28abba54&scoped=true"
import script from "./archivos-LDP-anios.vue?vue&type=script&lang=js"
export * from "./archivos-LDP-anios.vue?vue&type=script&lang=js"
import style0 from "./archivos-LDP-anios.vue?vue&type=style&index=0&id=28abba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28abba54",
  null
  
)

export default component.exports